// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentInfo_wrapper__VBzlr","icons":"PaymentInfo_icons__+T4d7","infoText":"PaymentInfo_infoText__p4NOj","dot":"PaymentInfo_dot__bc0P+"};